const menuOnClick = (link: string) => {
  const target = document.querySelector<HTMLElement>(link);
  if (!target) return;

  const header = document.querySelector<HTMLElement>("#header");
  const menuHeight = header ? header.offsetHeight : 0;

  const location = target.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: location - menuHeight,
    behavior: "smooth",
  });
};

export default menuOnClick;
